<div class="form-group" style="margin-bottom: 0px;">
  <label class="control-label">{{label}}</label>
  <input type="text" [(ngModel)]="model" (ngModelChange)="change()" [dpDayPicker]="datePickerConfig"
    [theme]="'dp-material'" class="form-control form-control-sm" [disabled]="disabled" />
</div>
